import React from 'react';
import { Flex, Icon } from '@chakra-ui/react';

import colors from '../../../styles/theme/foundation/colors';

const DropdownButton = ({ leftIcon, text, rightIcon, isDisabled, onClick, children, isHidden }) => {
  if (isHidden) return null;
  return (
    <Flex
      _disabled={{
        color: 'greyScale.500',
        _hover: {
          bgColor: colors.primaryScale['50'],
          color: colors.primaryScale['600'],
          cursor: 'pointer'
        }
      }}
      _hover={{ bgColor: colors.primaryScale['50'], color: colors.primaryScale['600'], cursor: 'pointer' }}
      alignItems="center"
      backgroundColor="white"
      borderRadius="md"
      color="greyScale.600"
      height="40px"
      isDisabled={isDisabled}
      justifyContent="flex-start"
      padding="10px 14px"
      textStyle="bodyMd500"
      textTransform="capitalize"
      variant="unstyled"
      width="100%"
      onClick={onClick}
    >
      {leftIcon && <Icon as={leftIcon} boxSize={4} mr={3} />}
      {text}
      {rightIcon && <Icon as={rightIcon} boxSize={4} ml="auto" />}
    </Flex>
  );
};

export default DropdownButton;
